import useMedias from '@Hooks/useMedias';
import { assets } from './assets';
import UIVideo from '@Components/Video';

import type { FC, HTMLAttributes } from 'react';

type VideoProps = HTMLAttributes<HTMLDivElement>;

const Video: FC<VideoProps> = (props) => {
  const { isMobile } = useMedias();

  return (
    <UIVideo
      src={isMobile ? assets.mobileVideo : assets.desktopVideo}
      poster={isMobile ? assets.mobileImage : assets.desktopImage}
      autoPlay
      loop
      {...props}
    />
  );
};

export default Video;
